import { z } from 'zod';

export const zodPreferredDuration = z.object({
    shortTerm: z.boolean().optional(),
    longTerm: z.boolean().optional(),
})
    .refine((schema) => {
        if (schema.shortTerm || schema.longTerm) {
            return true;
        } 
    
        return false;
    },
    { path: ["preferredDuration"], message: "select at least one value" });



const MAX_FILE_SIZE = 500000;
const ACCEPTED_DOC_TYPES = [
    ".doc",
    ".docx",
    ".pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ]

const ACCEPTED_IMAGE_TYPES = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/gif" ]


export const zodFileUpload =
    z.any(z.instanceof(File))
        .superRefine((arg, ctx) => {
            if (arg?.size === 0 || arg === undefined) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Please upload your Cv",
                    fatal: true
                  });
            }
            if (!ACCEPTED_DOC_TYPES.includes(arg?.type)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "file type not supported. Please upload .doc, .docx or pdf",
                    fatal: true
                  });
            }
            if (arg?.size >= MAX_FILE_SIZE) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "max file size is 5MB",
                    fatal: true
                  });
            }
        });

export const zodImageFileUpload = 
    z.any(z.instanceof(File))
        .superRefine((arg, ctx) => {
            if (arg?.size > 0) {
                if (!ACCEPTED_IMAGE_TYPES.includes(arg?.type)) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "file type not supported. Please upload .jpg, .jpeg, .png, .gif",
                        fatal: true
                      });
                }
                if (arg?.size >= MAX_FILE_SIZE) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        message: "max file size is 5MB",
                        fatal: true
                      });
                }
            }
        });

